export const setRegistrationEmail = (email: string) => {
  sessionStorage.setItem('registration_email', email);
};

export const getRegistrationEmail = (): string => sessionStorage.getItem('registration_email');

export const resetRegistrationEmail = () => {
  sessionStorage.removeItem('registration_email');
};
